export default __webpack_public_path__ + "static/media/achievement2-2.7f81d2ff.png";